var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resource-capacity"},[_c('div',{staticClass:"resource-capacity__input"},[_c('input',{attrs:{"type":"number","min":"0","placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":function($event){$event.preventDefault();$event.stopPropagation();return _vm.changeValue.apply(null, arguments)}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }